/*
 * @Author: Mike Cottingham 
 * @Date: 2018-04-23 23:12:29 
 * @Last Modified by: Mike Cottingham
 * @Last Modified time: 2019-05-02 11:38:32
 */

import ClientAppointmentListItem from "./ClientAppointmentListItem"
import FundingExpansionPanel from "./FundingExpansionPanel"
import PropTypes from "prop-types"
import React from "react"
import _ from "lodash"
import core from "../../core"
import layout from "../../layout"
import model from "../../../model"
import { moduleName } from "../constants"
import { directBillClients } from '../../../service/constants.js'
import "../appointment.css"

class ClientAppointmentList extends React.Component {
  constructor(props) {
    super(props)
  }

  onClick(clientAppointment, e) {
    e.preventDefault()
    this.props.onClick(clientAppointment)
  }

  render() {
    const { clientAppointments } = this.props
    const funders = _.map(_.uniqBy(_.map(clientAppointments), a => a.paymentSource), ca => ca.paymentSource).sort()
    const groups = funders.map(source => {
      const appointments = _.sortBy(_.filter(clientAppointments, ca => ca.paymentSource === source), (o) => o.client.fullName)
      const listItems = _.map(appointments, (clientAppointment, i) => (
        <ClientAppointmentListItem 
          clientAppointment={clientAppointment} 
          
          key={`${moduleName}-${i}`} 
          onClick={this.onClick.bind(this, clientAppointment)}
        />
      ))

      return (
        <FundingExpansionPanel 
          appointments={appointments}
          key={source} 
          title={`${source || "No Funding Source"} (${listItems.length})`} 
          items={listItems} 
          id={source} 
          isDirectBill={directBillClients.includes(source)}
          onClick={(appointment) => this.onClick.bind(this, appointment)}
        />
  
      )
    })

    return (
      <layout.components.FullWidthRow>
        <layout.components.Container>
          {groups.length ? groups : <core.components.NoItems />}
        </layout.components.Container>
      </layout.components.FullWidthRow>
    )
  }
}

ClientAppointmentList.propTypes = {
  clientAppointments: PropTypes.objectOf(model.ClientAppointmentShape),
  onClick: PropTypes.func
}

export default ClientAppointmentList